import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const getOption = createAsyncThunk(
    "setting/getOption",
    async (_, { rejectWithValue }) => {  
      try {
        const response = await api.get("/setting");
        return response.data.settingList; 
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

export const updateOption = createAsyncThunk(
    "setting/updateOption",
    async (data, { rejectWithValue }) => {  
      try {
        const response = await api.put("/setting", data);
        if (response.status !== 200) throw new Error('Failed to update option');
        return response.data;
      } catch (error) {
        // console.error('Failed to update option:', error);
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

  const settingSlice = createSlice({
    name: "setting",
    initialState: {
      loading: false,
      error: null,
      success: null,
      settingList : [],
      settings: {
        listPage: null,
        listScroll: null,
        listViewCount: 0,
        gridViewCount: 0,
        desc: null,
        asc: null,
        noticePeriod: 0
      }
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getOption.pending, (state) => {
            state.loading = true;
        })
        .addCase(getOption.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true;
            state.settingList = action.payload;
            const findAttribute = (id) => {
              const item = state.settingList.find(item => item.id === id);
              return item ? item.ATTRIBUTE01 : null;
            };

            state.settings = {
              listPage: findAttribute("LIST_PAGE"),
              listScroll: findAttribute("LIST_SCROLL"),
              listViewCount: Number(findAttribute("LIST_VIEW_COUNT")) || 0,
              gridViewCount: Number(findAttribute("GRID_VIEW_COUNT")) || 0,
              desc: findAttribute("DESC"),
              asc: findAttribute("ASC"),
              noticePeriod: Number(findAttribute("NOTICE_PERIOD")) || 0
            };

            const noticePeriod = Array.isArray(state.settingList) 
              ? state.settingList.find((item) => item.id === "NOTICE_PERIOD")
              : null;
            state.periodDate = noticePeriod ? noticePeriod.ATTRIBUTE01 : 0;
          })
        .addCase(getOption.rejected, (state, action) => {
            state.loading = false;
            state.success = null;
            state.error = action.payload;
        })
        .addCase(updateOption.pending, (state) => {
            state.loading = true;
            state.success = false;
            state.error = null;
        })
        .addCase(updateOption.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true;
            if(state.success === true){
              alert("설정 업데이트 성공")
            }
        })
        .addCase(updateOption.rejected, (state, action) => {
            state.loading = false;
            state.success = false;
            if(state.success === false){
              alert("설정 업데이트 오류")
            }
            state.error = action.payload;
        });
  }});
  
  export default settingSlice.reducer;